export const STRIPE_API_KEY = process.env.REACT_APP_STRIPE_API_KEY // 'pk_live_kVSignf4TBe9KTRKp4mxSelQ'
export const API_URL = process.env.REACT_APP_API_URL

